/*!
 * Lekonas Logo Cloud
 */

(() => {
  const SELECTOR = "[data-logo-cloud-section]";

  function init(section) {
    if (!section || section.dataset.lkLogoInit === "true") return;
    section.dataset.lkLogoInit = "true";

    const track = section.querySelector("[data-logo-track]");
    const slides = [...section.querySelectorAll("[data-logo-slide]")];
    const prev = section.querySelector("[data-logo-previous]");
    const next = section.querySelector("[data-logo-next]");
    const current = section.querySelector("[data-logo-current]");

    if (!track || slides.length < 2 || !prev || !next || !current) return;

    let index = 0;
    let timer = null;

    function slideLeft(i) {
      return slides[i].offsetLeft - track.offsetLeft;
    }

    function update() {
      current.textContent = String(index + 1);
      prev.disabled = index === 0;
      next.disabled = index >= slides.length - 1;
    }

    function scrollToIndex(i, smooth = true) {
      index = Math.max(0, Math.min(i, slides.length - 1));

      track.scrollTo({
        left: slideLeft(index),
        behavior:
          smooth &&
          !window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ? "smooth"
            : "auto",
      });

      update();
    }

    function syncFromScroll() {
      const left = track.scrollLeft;

      let closest = 0;
      let distance = Infinity;

      slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft - track.offsetLeft - left);
        if (d < distance) {
          distance = d;
          closest = i;
        }
      });

      index = closest;
      update();
    }

    prev.addEventListener("click", () => scrollToIndex(index - 1));
    next.addEventListener("click", () => scrollToIndex(index + 1));

    track.addEventListener(
      "scroll",
      () => {
        clearTimeout(timer);
        timer = setTimeout(syncFromScroll, 70);
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      clearTimeout(timer);
      timer = setTimeout(() => scrollToIndex(index, false), 120);
    });

    update();
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = document.getElementById(
      `LekonasLogoCloud-${event.detail.sectionId}`
    );

    if (section) {
      section.dataset.lkLogoInit = "false";
      init(section);
    }
  });

  document.addEventListener("shopify:section:select", (event) => {
    const section = document.getElementById(
      `LekonasLogoCloud-${event.detail.sectionId}`
    );

    if (section) init(section);
  });
})();